// extracted by mini-css-extract-plugin
module.exports = {"urgent-label":"ProductUrgentMessageLabel_urgent-label__Vm8hn"};